import { Locale } from '@headless-workspace/config';
import { ConfigByKeyRepository, Result } from '@headless-workspace/core-domain';
import { Target2SellConfigDTO } from './Target2SellConfigDTO';
import { mapTarget2SellConfig, Target2SellConfigValue } from './Target2SellConfigValue';

export const TARGET_2_SELL_CONFIG_KEY = 't2SConfig';

export interface Target2SellConfigRepositorySpec {
    fetchTarget2SellConfig(locale: Locale): Promise<Result<Target2SellConfigValue>>;
}

export class Target2SellConfigRepository extends ConfigByKeyRepository implements Target2SellConfigRepositorySpec {
    async fetchTarget2SellConfig(locale: Locale): Promise<Result<Target2SellConfigValue>> {
        return await this.getConfigByKey(TARGET_2_SELL_CONFIG_KEY, { locale }, (value) =>
            mapTarget2SellConfig(Target2SellConfigDTO.parse(value)),
        );
    }
}
